enum ScreenSet {
    accountSettings = 'accountSettings',
    completeRegistration = 'completeRegistration',
    editPassword = 'editPassword',
    forgotPassword = 'forgotPassword',
    forgotPasswordSent = 'forgotPasswordSent',
    instagramDeprecation = 'instagramDeprecation',
    linkAccounts = 'linkAccounts',
    login = 'login',
    loginSucceeded = 'loginSucceeded',
    reauthenticate = 'reauthenticate',
    register = 'register',
    resetPassword = 'resetPassword',
    socialConnections = 'socialConnections',
    verification = 'verification',
    verificationSent = 'verificationSent',
    verificationSucceeded = 'verificationSucceeded',

    EMPTY = '',
}

export function isScreenSet(name: any): name is ScreenSet {
    return typeof name === 'string' && name in ScreenSet;
}

export default ScreenSet;
